'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Caption1Stronger", {
    enumerable: true,
    get: function() {
        return Caption1Stronger;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useCaption1Strongerstyles = require("./useCaption1Stronger.styles");
const Caption1Stronger = (0, _createPreset.createPreset)({
    useStyles: _useCaption1Strongerstyles.useCaption1StrongerStyles,
    className: _useCaption1Strongerstyles.caption1StrongerClassNames.root,
    displayName: 'Caption1Stronger'
});
